import React, { Component } from "react";
import "./css/bootstrap.min.css";
import "./css/style.css";
import ReactDOM from "react-dom";
import ScreenSize from "./lib/ScreenSize";
import { AppContext } from "./lib/AppContext";
import AppRouter from "./lib/AppRouter";
import CheckRouteAndShowFilter from "./lib/CheckRouteAndShowFilter";
import { BrowserRouter as Router, Link } from "react-router-dom";

class App extends Component {
  constructor(state, props) {
    super(state, props);

    this.state = {
      dataTarget: "",
      route: "",
      search: "all",
      active: null
    };
  }

  //set the current nav option
  onChangeNavLink = value => {
    this.setState({ active: value });
  };

  //set the navbar dataTarget using the value from ScreenSize
  onChangeDataTarget = value => {
    this.setState({ dataTarget: value });
  };

  onChangeSearch = value => {
    this.setState({ search: value });
  };

  onChangeRoute = value => {
    //highlight the initial navbar link
    if (this.state.route === "") {
      this.highlightOption(value);
    }
    this.setState({ route: value });
  };

  toggleSelectedNavOption(position, route) {
    //only change link color if link clicked is different from last click
    if (this.state.route !== route) {
      if (this.state.active === position) {
        this.setState({ active: null });
      } else {
        this.setState({ active: position });
      }
    }
  }

  //get color for the link
  navOptionColor(position) {
    if (this.state.active === position) {
      return "#222";
    }
    return "#777";
  }

  //highlight the selected navbar link
  highlightOption(value) {
    switch (value) {
      case "/":
        return this.toggleSelectedNavOption(0, "/");
      case "/ace":
        return this.toggleSelectedNavOption(1, "/ace");
      case "/doremi":
        return this.toggleSelectedNavOption(2, "/doremi");
      case "/koryu":
        return this.toggleSelectedNavOption(3, "/koryu");
      case "/mickey3":
        return this.toggleSelectedNavOption(4, "/mickey3");
      case "/miracle":
        return this.toggleSelectedNavOption(5, "/miracle");
      default:
        return this.toggleSelectedNavOption(0, "/");
    }
  }

  render() {
    return (
      <Router>
        <span>
          {/* get the navbar dataTarget for the current screen width */}
          <ScreenSize
            value={this.state.screenWidth}
            onChangeDataTarget={this.onChangeDataTarget}
          />

          <div className="sectionmain">
            <div className="row text-center">
              <div className="col-centered">
                <nav className="navbar navbar-default">
                  <div className="container-fluid header-bar-padding-right">
                    <div className="navbar-header">
                      <div id="navLinks1" />
                      <Link
                        to="/"
                        className="navbar-brand"
                        data-toggle="collapse"
                        data-target={this.state.dataTarget}
                        onClick={() => {
                          this.toggleSelectedNavOption(0, "/");
                        }}
                        style={{ color: this.navOptionColor(0) }}
                      >
                        <h4 className="navigationLink">
                          <img
                            src={require("./rpgone.png")}
                            alt="Updates"
                            title="Updates"
                            className="logo"
                          />
                        </h4>
                      </Link>
                      <button
                        type="button"
                        className="navbar-toggle"
                        data-toggle="collapse"
                        data-target="#myNavbar"
                      >
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                      </button>
                    </div>

                    <div className="collapse navbar-collapse" id="myNavbar">
                      <ul className="nav navbar-nav mynavbar">
                        {/*<li className="contentBar1">
                          <span className="contentBar" />
                        </li>*/}
                        <li>
                          <Link
                            to="/ace"
                            data-toggle="collapse"
                            data-target={this.state.dataTarget}
                            className="noPaddingLeft"
                            onClick={() => {
                              this.toggleSelectedNavOption(1, "/ace");
                            }}
                            style={{ color: this.navOptionColor(1) }}
                          >
                            <h4 className="navigationLink">
                              <b>Aim for the Ace!</b>
                            </h4>
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/doremi"
                            data-toggle="collapse"
                            data-target={this.state.dataTarget}
                            className=""
                            onClick={() => {
                              this.toggleSelectedNavOption(2, "/doremi");
                            }}
                            style={{ color: this.navOptionColor(2) }}
                          >
                            <h4 className="navigationLink">
                              <b>DoReMi Fantasy</b>
                            </h4>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/koryu"
                            data-toggle="collapse"
                            data-target={this.state.dataTarget}
                            onClick={() => {
                              this.toggleSelectedNavOption(3, "/koryu");
                            }}
                            style={{ color: this.navOptionColor(3) }}
                          >
                            <h4 className="navigationLink">
                              <b>Koryu No Mimi</b>
                            </h4>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/mickey3"
                            data-toggle="collapse"
                            data-target={this.state.dataTarget}
                            onClick={() => {
                              this.toggleSelectedNavOption(4, "/mickey3");
                            }}
                            style={{ color: this.navOptionColor(4) }}
                          >
                            <h4 className="navigationLink">
                              <b>Magical Quest 3</b>
                            </h4>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/miracle"
                            data-toggle="collapse"
                            data-target={this.state.dataTarget}
                            className="noPaddingRight"
                            onClick={() => {
                              this.toggleSelectedNavOption(5, "/miracle");
                            }}
                            style={{ color: this.navOptionColor(5) }}
                          >
                            <h4 className="navigationLink">
                              <b>Miracle Girls</b>
                            </h4>
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {/* show updates or debug filter if required */}
                    <CheckRouteAndShowFilter
                      search={this.state.search}
                      onChangeSearch={this.onChangeSearch}
                      route={this.state.route}
                      onChangeRoute={this.onChangeRoute}
                    />
                  </div>
                </nav>
              </div>

              <AppContext.Provider value={{ search: this.state.search }}>
                <AppContext.Consumer>
                  {({ search }) => (
                    <span>
                      <AppRouter onChangeNavLink={this.onChangeNavLink} />
                    </span>
                  )}
                </AppContext.Consumer>
              </AppContext.Provider>
            </div>
          </div>

          {/* footer */}
          <div className="row text-center">&#169; 2021 RPGONE</div>
        </span>
      </Router>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));

export default App;



// WEBPACK FOOTER //
// ./src/App.js